var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResizer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.866,
    viewBox: "0 0 20 18.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    "data-name": "Group 1334",
    transform: "translate(-1005 -1143)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_876",
    "data-name": "Line 876",
    x1: 19,
    y2: 18,
    transform: "translate(1005.5 1143.5)",
    fill: "none",
    stroke: "#0fc8e5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_877",
    "data-name": "Line 877",
    x1: 14,
    y2: 13,
    transform: "translate(1010.5 1148.5)",
    fill: "none",
    stroke: "#0fc8e5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_878",
    "data-name": "Line 878",
    x1: 9.5,
    y2: 9,
    transform: "translate(1015 1152.5)",
    fill: "none",
    stroke: "#0fc8e5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M-6605.234-7825.936v-19H-6623",
    transform: "translate(-6820.437 7766.501) rotate(90)",
    fill: "none",
    stroke: "#0fc8e5",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizer);
export default __webpack_public_path__ + "static/media/Resizer.04d3dd00f09b546b64c8b27eab73f075.svg";
export { ForwardRef as ReactComponent };